import ComposeMail from './ComposeMail';

const path = '/admin/dashboard/mail';

const adminMailRoutes = [
  {
    name: 'Compose',
    path: `${path}/compose`,
    icon: 'envelope',
    component: ComposeMail,
  },
];
export default adminMailRoutes;

export const redirects = [
  {
    from: path,
    to: `${path}/compose`,
  },
  {
    from: `${path}/*`,
    to: `${path}/compose`,
  },
];
